import { useCallback } from "react";
import { proxy, ref, useSnapshot } from "valtio";
import { useMessage } from "./useMessage";

const definitionState = proxy({
	definitionToReuse: undefined as eXpress.core.IDefinition | undefined,
	actions: {
		setDefinition(def: eXpress.core.IDefinition | undefined) {
			definitionState.definitionToReuse = def ? ref(def) : undefined;
		},
		clearDefinition() {
			definitionState.definitionToReuse = undefined;
		},
	},
});

export function useResetDefinitionForOptions() {
	const { definitionToReuse } = useSnapshot(definitionState);

	const setDefinition = useCallback((def: eXpress.core.IDefinition | undefined) => {
		definitionState.actions.setDefinition(def);
	}, []);

	useMessage(
		useCallback((message) => {
			// If another commands is executed, don't reuse cloned definition but the latest definition
			if (
				!(message instanceof eXpress.core.AlternativeProductSwitchedMessage) &&
				eXpress.core.isCommandMessage(message)
			) {
				definitionState.actions.clearDefinition();
			}
		}, []),
	);

	return [definitionToReuse as eXpress.core.IDefinition | undefined, setDefinition] as const;
}
